export const APP_ENV = process.env.APP_ENV || process.env.VUE_APP_APP_ENV;

export const isDevelopment = APP_ENV === 'development';

export const isTest = APP_ENV === 'test';

export const isProduction = !isDevelopment && !isTest;

const STAGING_ENV = 'staging';

const PREVIEW_ENV = 'preview';

const getBaseEnv = () => {
  try {
    const baseEnv = localStorage.getItem('BASE_ENV');
    if (baseEnv) {
      return baseEnv;
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Local storage is not supported', e);
  }
  return undefined;
};

export const BASE_ENV = getBaseEnv();

export const getEnv = () => {
  const splitHost = window.location.host.split('.');
  if (splitHost.length > 0) {
    const subdomain = splitHost[0];
    if (/^ca/.test(subdomain)) {
      return BASE_ENV === STAGING_ENV ? 'ca_staging' : 'ca_production';
    }
    if (/^eu/.test(subdomain)) {
      return BASE_ENV === STAGING_ENV ? 'eu_staging' : 'eu_production';
    }

    if (/^staging/.test(subdomain)) {
      return STAGING_ENV;
    }

    if (/^static-builds/.test(subdomain)) {
      return PREVIEW_ENV;
    }
  }

  if (BASE_ENV === STAGING_ENV) {
    return STAGING_ENV;
  }

  if (BASE_ENV) {
    return BASE_ENV;
  }

  return APP_ENV || 'production';
};

export const ENV = getEnv();

export const getBaseUrl = () => {
  const currentOrigin = window.location.origin;
  if (!currentOrigin.endsWith('inscribe.ai')) {
    return `${currentOrigin}/`;
  }
  const apiSubdomain = {
    production: 'api',
    preview: 'api',
    development: 'local-api',
  }[ENV];
  const envSubdomain = ENV.replace(/_/, '-').replace('-production', '');
  return `https://${apiSubdomain || `${envSubdomain}-api`}.inscribe.ai/`;
};

export const BASE_URL = getBaseUrl();
